const footer = {
    ru: {
        nav_1: "Главная",
        nav_2: "Услуги и кейсы",
        nav_3: "О нас",
        mail: "k.levi@aroundgroupp.com",
        tel: "+7 700 964-39-76"
    },

    eng: {
        nav_1: "Main page",
        nav_2: "Services & Cases",
        nav_3: "About us",
        mail: "k.levi@aroundgroupp.com",
        tel: "+7 700 964-39-76"
    }
}

export default footer